export enum StripePlatformRegion {
  USA = 'USA',
  AU = 'AU',
}

export default StripePlatformRegion;
